import { render, staticRenderFns } from "./TransactionsShow.vue?vue&type=template&id=32917562&"
import script from "./TransactionsShow.vue?vue&type=script&lang=js&"
export * from "./TransactionsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports